import { ParseSpec } from 'prosemirror-markdown';

import { BaseExtension } from '@lyearn/lygo-core';

import { NODE_NAME } from './consts';
import plugins from './plugins';

export default class Doc extends BaseExtension {
  get name(): string {
    return NODE_NAME;
  }

  parseMarkdown(): void | ParseSpec {
    return {
      block: NODE_NAME,
    };
  }

  plugins = plugins;
}
